export const IMAGES = {
  campus: "https://customer-assets-v7afamib.emergentagent.net/job_58562109-0960-4437-8d66-4faf28740b9c/artifacts/bqu389tn_CAMPUS%20VIEW%20.jpeg",
  principal: "https://customer-assets-v7afamib.emergentagent.net/job_58562109-0960-4437-8d66-4faf28740b9c/artifacts/fn3cikua_Dr.%20haoneo%20photo.png",
  principalSign: "https://customer-assets-cm19k8pv.emergentagent.net/job_christian-edu-portal/artifacts/qjvlflhb_Dr.%20Haoneo%20Sign.png",
  logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_christian-edu-portal/artifacts/pzkko4my_Logo.jpeg",
  students: "https://images.unsplash.com/photo-1543269865-cbf427effbad?crop=entropy&cs=srgb&fm=jpg&q=85",
  texture: "https://images.unsplash.com/photo-1524351543168-8e38787614e9?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const COLLEGE = {
  name: "Kanggui Christian College",
  short: "KCC",
  motto: "Learn & Serve",
  founded: "1995",
  university: "Manipur University",
  affiliation: "Affiliated to Manipur University",
  affNo: "MU/MU/P66/2005/DCD/737",
  location: "Kangpokpi, Ward No. 16, Manipur",
  website: "kangguichristiancollege.in",
  email: "info@kangguichristiancollege.in",
  phone: "+91 8414809043",
  principal: "Rev. Dr. Paokhohao Haokip",
  social: {
    handle: "kangguichristiancollege",
    facebook: "https://facebook.com/kangguichristiancollege",
    instagram: "https://instagram.com/kangguichristiancollege",
    youtube: "https://youtube.com/@kangguichristiancollege",
  },
};

export const ABC_CREDITS_URL = "https://www.abc.gov.in/";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Notice", to: "/notice" },
  { label: "Course", to: "/course" },
  { label: "Department", to: "/department" },
  {
    label: "Student",
    to: "/student",
    children: [
      { label: "Student Life", to: "/student" },
      { label: "Routine", to: "/routine" },
      { label: "Syllabus", to: "/syllabus" },
      { label: "Prospectus", to: "/prospectus" },
      { label: "Academic Bank of Credit", href: ABC_CREDITS_URL, external: true },
      { label: "Marksheet", to: "/marksheet" },
    ],
  },
  { label: "Library", to: "/library" },
  { label: "ID Card", to: "/id-card" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Aligned with NEP 2020",
    text: "Our curriculum embraces the National Education Policy — multidisciplinary learning, flexible credit systems and a foundation rooted in Indian knowledge traditions.",
  },
  {
    no: "02",
    title: "The Four Year Undergraduate Programme",
    text: "Students journey through the FYUP with multiple entry and exit options, earning certificates, diplomas and honours degrees with research at the final stage.",
  },
  {
    no: "03",
    title: "Faith, Character & Community",
    text: "As a Christian institution founded in 1995 in the hills of Kanggui, we nurture not only intellect but integrity, service and a deep sense of belonging.",
  },
];

export const COURSES = [
  { code: "BA", title: "Bachelor of Arts (FYUP)", years: "4 Years", desc: "Multidisciplinary humanities with majors, minors and skill-based courses under NEP.", subjects: ["English", "History", "Political Science", "Economics", "Sociology", "Education"] },
  { code: "COMP", title: "Computer Applications", years: "1–3 Years", desc: "Diploma & certificate computer programmes covering programming, office tools and IT skills.", subjects: ["DCA", "PGDCA", "Tally", "Office Automation"] },
  { code: "CERT", title: "Certificate & Diploma Exits", years: "1–3 Years", desc: "Flexible exit options — Certificate (Year 1), Diploma (Year 2) and Degree (Year 3).", subjects: ["Skill Courses", "Vocational", "Ability Enhancement"] },
];

export const DEPARTMENTS = [
  { name: "Department of English", university: "Manipur University", desc: "Literature, communicative English and critical writing with seminar-led teaching." },
  { name: "Department of Economics", university: "Manipur University", desc: "Micro & macro economics, statistics and development studies." },
  { name: "Department of Sociology", university: "Manipur University", desc: "Society, culture and social research methods." },
  { name: "Department of Political Science", university: "Manipur University", desc: "Political theory, governance, and international relations." },
  { name: "Department of History", university: "Manipur University", desc: "Indian and world history with regional heritage studies." },
  { name: "Department of Education", university: "Manipur University", desc: "Pedagogy, educational psychology and teaching practice." },
  { name: "Department of Computer", university: "Manipur University", desc: "Computer applications, programming and modern IT skills." },
];

export const STUDENT_LIFE = [
  { title: "Admissions", desc: "Simple, transparent admission into the FYUP under NEP 2020 guidelines." },
  { title: "ID Card Registration", desc: "Register online and instantly generate your official college PVC ID card." },
  { title: "Scholarships", desc: "Merit and need-based support for deserving students of the region." },
  { title: "Clubs & Societies", desc: "Literary, cultural, worship and community-service groups." },
  { title: "Library & Resources", desc: "A growing library with digital access and quiet study spaces." },
  { title: "Sports & Athletics", desc: "Football, volleyball and annual inter-class tournaments." },
];

export const DEPARTMENT_OPTIONS = [
  "English", "Economics", "Sociology", "Political Science", "History", "Education", "Computer", "Administration", "Office Staff",
];

export const BLOOD_GROUPS = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];

export const DEFAULT_GALLERY = [
  { image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Graduation Ceremony" },
  { image: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Campus Life" },
  { image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Classroom Session" },
  { image: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Annual Function" },
];

export const DEFAULT_SUBJECTS = [
  { name: "English", category: "Major", desc: "Literature, language and communicative English." },
  { name: "History", category: "Major", desc: "Indian, world and regional heritage history." },
  { name: "Political Science", category: "Major", desc: "Political theory, governance and IR." },
  { name: "Economics", category: "Major", desc: "Micro, macro and development economics." },
  { name: "Sociology", category: "Major", desc: "Society, culture and social research." },
  { name: "Education", category: "Major", desc: "Pedagogy, psychology and teaching practice." },
  { name: "Computer Application", category: "Skill", desc: "Offered in collaboration with AISECT University." },
  { name: "Environmental Studies", category: "Value-Added", desc: "Compulsory ability enhancement course under NEP." },
];

export const DEFAULT_TEAM = [
  { photo: "https://images.unsplash.com/photo-1758685734503-58a8accc24e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", name: "Prof. K. Haokip", role: "Head, Department of English" },
  { photo: "https://images.unsplash.com/photo-1758685734511-4f49ce9a382b?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", name: "Dr. L. Kipgen", role: "Department of Economics" },
  { photo: "https://images.unsplash.com/photo-1504257432389-52343af06ae3?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", name: "Prof. S. Doungel", role: "Department of History" },
  { photo: "https://images.unsplash.com/photo-1758685847747-597ce085906e?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", name: "Dr. M. Chongloi", role: "Department of Education" },
];

export const DEFAULT_SEMESTERS = [
  { semester: "Semester I", program: "FYUP", subjects: ["Major – English", "Minor Elective", "Multidisciplinary Course", "Ability Enhancement (English)", "Value-Added Course"] },
  { semester: "Semester II", program: "FYUP", subjects: ["Major – English", "Minor Elective", "Multidisciplinary Course", "Ability Enhancement (MIL)", "Skill Enhancement Course"] },
  { semester: "Semester III", program: "FYUP", subjects: ["Major – Core", "Minor Elective", "Multidisciplinary Course", "Skill Enhancement Course", "Value-Added Course"] },
  { semester: "Semester IV", program: "FYUP", subjects: ["Major – Core", "Major – Core", "Minor Elective", "Skill Enhancement Course"] },
  { semester: "Semester V", program: "FYUP", subjects: ["Major – Core", "Major – Core", "Minor Elective", "Internship / Field Work"] },
  { semester: "Semester VI", program: "FYUP", subjects: ["Major – Core", "Major – Core", "Minor Elective", "Project Work"] },
  { semester: "Semester VII", program: "FYUP (Honours)", subjects: ["Major – Advanced", "Major – Advanced", "Research Methodology", "Elective"] },
  { semester: "Semester VIII", program: "FYUP (Honours w/ Research)", subjects: ["Major – Advanced", "Dissertation / Research Project", "Elective", "Seminar"] },
];

export const DEFAULT_RECORDS = [];

export const DEFAULT_MARKSHEETS = [];

export const DEFAULT_SYLLABUS = [];
export const DEFAULT_PROSPECTUS = [];

export const DEFAULT_SLIDES = [
  { image: "https://images.unsplash.com/photo-1562774053-701939374585?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", caption: "Welcome to Kanggui Christian College" },
  { image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", caption: "Shaping Future Leaders" },
  { image: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", caption: "A Vibrant Campus in the Kanggui Hills" },
];

export const MARKSHEET_YEARS = Array.from({ length: 11 }, (_, i) => String(2020 + i));

const RT_SEMS = ["Semester I", "Semester II", "Semester III", "Semester IV", "Semester V", "Semester VI", "Semester VII", "Semester VIII"];
const RT_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const RT_SLOTS = ["Period 1", "Period 2", "Period 3", "Period 4", "Period 5", "Period 6", "Period 7"];
const blankRoutine = () => ({
  slots: [...RT_SLOTS],
  times: RT_SLOTS.map(() => ""),
  days: Object.fromEntries(RT_DAYS.map((d) => [d, Array.from({ length: RT_SLOTS.length }).map(() => ({ subject: "", room: "", teacher: "" }))])),
});
export const ROUTINE_SEMS = RT_SEMS;
export const ROUTINE_DAYS = RT_DAYS;
export const DEFAULT_ROUTINES = Object.fromEntries(RT_SEMS.map((s) => [s, blankRoutine()]));

export const DEFAULT_ROUTINE = {
  slots: ["Period 1", "Period 2", "Period 3", "Period 4", "Period 5", "Period 6"],
  days: {
    Monday: ["", "", "", "", "", ""],
    Tuesday: ["", "", "", "", "", ""],
    Wednesday: ["", "", "", "", "", ""],
    Thursday: ["", "", "", "", "", ""],
    Friday: ["", "", "", "", "", ""],
    Saturday: ["", "", "", "", "", ""],
  },
};

export const DEFAULT_SETTINGS = {
  college: {
    name: COLLEGE.name, short: COLLEGE.short, motto: COLLEGE.motto, founded: COLLEGE.founded,
    university: COLLEGE.university, affiliation: COLLEGE.affiliation, affNo: COLLEGE.affNo,
    location: COLLEGE.location, website: COLLEGE.website, email: COLLEGE.email, phone: COLLEGE.phone, principal: COLLEGE.principal,
  },
  social: { ...COLLEGE.social },
  home: {
    heroSubtitle: "A hill-town institution shaping young minds through knowledge, character and a living community of faith.",
    marquee: "Knowledge ✦ Character ✦ Community",
    manifestoHeading: "Education built for the new India, rooted in the hills.",
    manifesto: MANIFESTO,
    principalMessage: "Our mission is to form not merely graduates, but people of wisdom and conscience — ready to serve their community and carry the light of learning back to the hills.",
    coursesHeading: "Four-year journeys under NEP 2020.",
  },
  student: {
    introTitle: "A place to belong, a place to grow.",
    introText: "From your first orientation to your final research project, the college walks with you — offering scholarships, clubs, mentorship and a safe campus surrounded by the Kanggui hills.",
  },
  routine: DEFAULT_ROUTINE,
  routines: DEFAULT_ROUTINES,
  images: {
    campus: IMAGES.campus,
    principal: IMAGES.principal,
    gallery: IMAGES.students,
    logo: IMAGES.logo,
  },
  pages: {
    notice: { label: "Announcements", title: "Notice Board", subtitle: "Official announcements, admission updates, examination schedules and events from the college administration." },
    course: { label: "Programmes", title: "Courses", subtitle: "Undergraduate programmes designed under the Four Year Undergraduate Programme (FYUP) framework with multiple entry and exit options as per NEP 2020." },
    department: { label: "Faculties", title: "Departments", subtitle: `Academic departments delivering the multidisciplinary curriculum. ${COLLEGE.affiliation} (Aff. No. ${COLLEGE.affNo}).` },
    student: { label: "Campus Life", title: "Student", subtitle: "Life at Kanggui Christian College is more than lectures — it is a community of growth, faith, sport, culture and lifelong friendship." },
    idcard: { label: "e-Registration", title: "ID Card Maker", subtitle: "Register your details to instantly generate an official college PVC identity card. Your submission is recorded with the college administration." },
    library: { label: "Resources", title: "Library", subtitle: "Browse the college library catalogue. Books are issued at the library counter by the librarian." },
  },
};
